import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/arrow-to-top.svg'


const _hoisted_1 = { class: "back-top-wrapper" }
const _hoisted_2 = { class: "text-container" }
const _hoisted_3 = { class: "text default-text-back-to-top" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back-top-component",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toTop()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("back-to-top-component.back-to-top")), 1)
      ]),
      _hoisted_4
    ])
  ]))
}